/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Surface_Dock_RestoreInputs */

const en_surface_dock_restore = /** @type {(inputs: Surface_Dock_RestoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Restore ${i?.title}`)
};

const ar_surface_dock_restore = /** @type {(inputs: Surface_Dock_RestoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`استعادة ${i?.title}`)
};

const bn_surface_dock_restore = /** @type {(inputs: Surface_Dock_RestoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} পুনরুদ্ধার করুন`)
};

const de_surface_dock_restore = /** @type {(inputs: Surface_Dock_RestoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} wiederherstellen`)
};

const es_surface_dock_restore = /** @type {(inputs: Surface_Dock_RestoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Restaurar ${i?.title}`)
};

const fr_surface_dock_restore = /** @type {(inputs: Surface_Dock_RestoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Restaurer ${i?.title}`)
};

const pt_surface_dock_restore = /** @type {(inputs: Surface_Dock_RestoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Restaurar ${i?.title}`)
};

const zh_surface_dock_restore = /** @type {(inputs: Surface_Dock_RestoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`恢复 ${i?.title}`)
};

const tr_surface_dock_restore = /** @type {(inputs: Surface_Dock_RestoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} penceresini geri yükle`)
};

const ru_surface_dock_restore = /** @type {(inputs: Surface_Dock_RestoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Восстановить ${i?.title}`)
};

const pl_surface_dock_restore = /** @type {(inputs: Surface_Dock_RestoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Przywróć ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Restore {title}" |
*
* @param {Surface_Dock_RestoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const surface_dock_restore = /** @type {((inputs: Surface_Dock_RestoreInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Surface_Dock_RestoreInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_surface_dock_restore(inputs)
	if (locale === "bn") return bn_surface_dock_restore(inputs)
	if (locale === "de") return de_surface_dock_restore(inputs)
	if (locale === "es") return es_surface_dock_restore(inputs)
	if (locale === "fr") return fr_surface_dock_restore(inputs)
	if (locale === "pt") return pt_surface_dock_restore(inputs)
	if (locale === "zh") return zh_surface_dock_restore(inputs)
	if (locale === "tr") return tr_surface_dock_restore(inputs)
	if (locale === "ru") return ru_surface_dock_restore(inputs)
	if (locale === "pl") return pl_surface_dock_restore(inputs)
	return en_surface_dock_restore(inputs)
});